const Loading = () => {
  return (
    <div className="loading-block" role="status" aria-live="polite">
      <div className="spinner spinner--accent" aria-hidden="true" />
      <p>Loading data…</p>
    </div>
  );
};

export default Loading;
